// Vendor libraries
import { combineReducers } from '@ngrx/store';
// Reducers
import { showRecessions } from 'TargetRatesApp/apps/target-rates-app/state/show-recessions/show-recessions.reducer';
export const targetRates = combineReducers({
    showRecessions,
});
